export const YOUTUBE_URL = "https://www.youtube.com/@TheCapChroniclesTV";

export const SKOOL_URL = "https://www.skool.com/relocate-pro-portugal-4330/about?ref=16a4242d7dcc498e857913309e84bb83";

export const BOOKS_BY_URL = "https://books.by/capchronicles";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Stories", to: "/stories" },
  { label: "Characters", to: "/characters" },
  { label: "Media", to: "/media" },
  { label: "News", to: "/news" },
  { label: "Community", to: "/community" },
  { label: "Contact", to: "/contact" },
];

export const BOOKS = [
  {
    id: "the-magic-in-you",
    chapter: "Book One",
    title: "The Magic in You",
    cover: "/images/magic-in-you-cover.jpg",
    featured: true,
    description:
      "A children's book about self-confidence for ages 4-8 , though it never feels like a lesson. A glowing baseball. A journey around the world. And a secret your little explorer will whisper back to you before the last page.",
    themes: ["Confidence", "Wonder", "Heart"],
    seoTitle: "The Magic in You: A Children's Book About Self-Confidence (Ages 4-8)",
    seoDesc: "A read-aloud picture book for ages 4-8 about self-belief: a glowing baseball whisks a boy around the world to discover the magic was inside him all along.",
  },
  {
    id: "the-magic-in-shoe",
    chapter: "Book Two",
    title: "The Magic in Shoe",
    cover: "/images/magic-in-shoe-cover.jpeg",
    featured: false,
    description:
      "A rhyming picture book about courage for ages 4-8. The smallest kid on the biggest stage. Red converse shoes that had seen a lot of living. Nobody in the audience expected the shoes to sparkle that night, least of all her.",
    themes: ["Rhyme", "Courage", "Self-Belief"],
    seoTitle: "The Magic in Shoe: A Rhyming Picture Book About Courage (Ages 4-8)",
    seoDesc: "A rhyming read-aloud book for kids ages 4-8 about stage fright and believing in yourself, where red converse shoes sparkle every time she dares to step.",
  },
  {
    id: "the-places-we-carry",
    chapter: "Book Three",
    title: "The Places We Carry",
    cover: "/images/places-we-carry-cover.jpeg",
    featured: false,
    description:
      "A picture book about kindness and memory for ages 4-8. Some places you visit. Some places you carry. One boy walks through oceans, valleys, forests, and deserts collecting moments he can't explain, until the desert explains them for him.",
    themes: ["Kindness", "Memory", "Empathy"],
    seoTitle: "The Places We Carry: A Picture Book About Kindness & Memory (Ages 4-8)",
    seoDesc: "A lyrical picture book for ages 4-8 about kindness, empathy, and the places we carry in our hearts, on a journey through deserts, valleys, forests, and snow peaks.",
  },
  {
    id: "a-little-goes-a-long-way",
    chapter: "Activity & Coloring Book",
    title: "A Little Goes a Long Way",
    cover: "/images/alglw-cover.png",
    featured: false,
    price: "$11.99",
    storyLink: "https://theditr.org",
    description:
      "A Little Goes a Long Way was inspired by the real-world work behind The DITR, where sports equipment and opportunities have been shared with children in Africa. The book turns that idea into an interactive journey kids can explore through coloring, activities, travel, and discovery.",
    themes: ["Coloring", "Activities", "Kindness"],
    seoTitle: "A Little Goes a Long Way: Activity & Coloring Book (Ages 4-8)",
    seoDesc: "A Little Goes a Long Way is an activity and coloring book for kids ages 4-8. Follow one special box across the world with coloring pages, activities, and acts of kindness.",
  },
];

export const CHARACTERS = [
  {
    id: "boy",
    name: "The Boy",
    role: "The Explorer",
    from: "The Magic in You",
    img: "/images/char-pip.png",
    short: "A curious young adventurer with a backpack, a rolled-up map, and questions bigger than the horizon.",
    long: "He never sets out to be brave. He just can't leave a question unanswered. Where his map leads, and why it keeps redrawing itself, is a secret the first story keeps until the very last page.",
    quote: "The map only changes when you do.",
  },
  {
    id: "magic-shoe",
    name: "The Magic in Shoe",
    role: "The Little Star",
    from: "The Magic in Shoe · A standalone story",
    img: "/images/magic-in-shoe-cover.jpeg",
    short: "A little girl in red converse shoes that sparkle with golden magic every time she believes in herself.",
    long: "The smallest kid on the biggest stage, in red converse shoes that had seen a lot of living. Nobody knows what made them sparkle that night, but everyone in the front row swears they saw it happen.",
    quote: "The magic was never in the shoes. It was in the steps she dared to take.",
  },
  {
    id: "magic-baseball",
    name: "The Magic Baseball",
    role: "The Spark",
    from: "The Magic in You",
    img: "/images/char-baseball.png",
    short: "A mysterious baseball glowing with golden light, the spark that starts every adventure and the heart of The Magic in You.",
    long: "It arrived glowing, humming, and impossible to ignore. Where it leads the boy, and why it chose him, is the heart of The Magic in You. Some say the ball holds the magic. The last page disagrees.",
    quote: "The magic was never the ball. It was you.",
  },
  {
    id: "shadow",
    name: "The Shadow",
    role: "The Quiet Companion",
    from: "The Places We Carry",
    img: "/images/char-shadow.png",
    short: "A mysterious cloaked wanderer standing where the dunes meet the sun, found at the very edge of the desert.",
    long: "At the edge of the dunes, where the sun melts into the sand, a cloaked figure stands waiting. The boy has questions. The Shadow has none, only answers, and only for those who sit still long enough.",
    quote: "Some guides only appear when you stop walking.",
  },
];

export const WORLD_HOTSPOTS = [
  { x: "12%", y: "55%", name: "The Rolling Ocean", desc: "Waves that clap like friends you haven't met yet." },
  { x: "32%", y: "28%", name: "The Snow Peaks", desc: "Where the air is thin and courage runs deep." },
  { x: "50%", y: "62%", name: "The Green Valley", desc: "A place to plant seeds, and trust they'll grow." },
  { x: "68%", y: "48%", name: "The Whispering Forest", desc: "Trees that keep every secret ever told beneath them." },
  { x: "88%", y: "58%", name: "The Golden Beach", desc: "Where the desert finally learns to dance." },
];

export const NEWS = [
  {
    id: "summer-reading-list",
    date: "August 2026",
    tag: "Reading Lists",
    title: "Summer reading list: gentle adventures for ages 4-8",
    excerpt: "Five picture books about courage, kindness, and wide-open places, perfect for slow summer story-times and bedtime reading.",
    img: "/images/char-pip.png",
  },
  {
    id: "book-one",
    date: "June 2026",
    tag: "Books",
    title: "The Magic in You: the first story is here",
    excerpt: "Book One of The Cap Chronicles has arrived. We won't tell you what the magic is, only where to find it.",
    img: "/images/news-book.png",
  },
  {
    id: "storytime-tour",
    date: "May 2026",
    tag: "Events",
    title: "Story-time under the trees: autumn tour",
    excerpt: "We're packing the lanterns and the blankets, because outdoor readings and watch-parties are coming to parks and libraries this autumn.",
    img: "/images/news-event.png",
  },
  {
    id: "studio-diary",
    date: "April 2026",
    tag: "Studio",
    title: "Inside the studio: painting the Vale",
    excerpt: "Watercolour, gouache, and a lot of cups of tea. A look at how the world of The Cap Chronicles comes to life.",
    img: "/images/news-art.png",
  },
];

export const GALLERY = [
  { src: "/images/gallery-balloon.png", title: "Over the Patchwork Fields", kind: "Artwork" },
  { src: "/images/gallery-night.png", title: "The Longest Night", kind: "Artwork" },
  { src: "/images/world-pano.png", title: "The Vale of Whispering Winds", kind: "Artwork" },
  { src: "/images/gallery-sketch.png", title: "First sketches of the boy & friends", kind: "Behind the scenes" },
  { src: "/images/news-art.png", title: "The studio desk, mid-chapter", kind: "Behind the scenes" },
  { src: "/images/book-cover.png", title: "The Places We Carry (key art)", kind: "Artwork" },
  { src: "/images/places-journey-map.png", title: "The Places We Carry (the journey map)", kind: "Behind the scenes" },
];

export const TRAILERS = [
  { title: "The Outfield (Original Clip)", length: "3:47", img: "/images/hero.png", to: "/watch/the-outfield" },
  { title: "The Cap Chronicles (Series Trailer)", length: "1:24", img: "/images/hero-dunes.png" },
  { title: "The Magic in You (Book One)", length: "12:04", img: "/images/magic-in-you-cover.jpg" },
  { title: "The Magic in Shoe (Book Two)", length: "11:32", img: "/images/magic-in-shoe-cover.jpeg" },
  { title: "The Places We Carry (Book Three)", length: "10:57", img: "/images/places-we-carry-cover.jpeg" },
];

export const CLIPS = [
  {
    id: "the-outfield",
    title: "The Outfield",
    kind: "Original Clip",
    length: "Short",
    img: "/images/hero.png",
    videoId: "MV1Cp900lTE",
    short: true,
    description:
      "Out past the fence, where the grass grows tall and summer stretches forever, something is about to happen. Our original animated clip, best watched without knowing any more than that.",
    seoTitle: "The Outfield: Watch the Original Clip | The Cap Chronicles",
    seoDesc: "Watch The Outfield, the original animated clip from The Cap Chronicles, a gentle baseball story for kids ages 4-8 about patience and being ready for your moment.",
  },
];

export const MARQUEE_WORDS = ["Courage", "Imagination", "Wonder", "Curiosity", "Resilience", "Friendship"];
